<template>
  <span v-if="campaign.video_view_rate !== null && ['YouTube'].includes(campaign.channel_title)"
        class="campaign-video-view-rate">
        <abbr v-if="campaign.channel_title === 'YouTube'" title="Video view rate">VVR</abbr>
        <percent-rate :rate="campaign.video_view_rate" :min_rate="min_rate(campaign.channel_title, 'video_view')">
        </percent-rate>
  </span>
</template>

<script>
import "./campaign-video-view-rate.scss";
import PercentRate from "../percent-rate/percent-rate.vue"
import channel_rates from "../../lib/channel-rates";

export default {
  name: "campaign-video-view-rate",
  props: {
    campaign: {
      required: true,
    },
    channels: {
      required: true,
    },
  },
  components: {
    PercentRate,
  },
  data() {
    return {}
  },
  methods: {
    min_rate(channel_title, rate) {
      return channel_rates(this.channels, channel_title, rate)
    },
  },
  computed: {},
}
</script>
